import * as types from './action-types';
import {queryStringToObject} from '../services/utils';

function receiveExperiments(experiments) {
  return {
    type: types.RECEIVE_EXPERIMENTS,
    experiments
  };
}

/**
 * Add experiments from url query string
 * Used for QA, testing
 * @array queryStrings
 */
export function addExperimentsFromQuery(queryStrings) {
  return (dispatch, getState) => {
    const fromUrl = {};
    const arrayArrays = queryStrings.map((s) => queryStringToObject(s).experiments);
    const experiments = arrayArrays.filter(e => e).join(',').split(',').filter(e => e);
    experiments.forEach((exp) => {
      fromUrl[exp] = 'true';
    });

    if (experiments.length !== 0) {
      const old = getState().mode.experiments;
      dispatch(receiveExperiments(Object.assign({}, old, fromUrl)));
    }
  };
}


export function changeVertical(vertical) {
  return {
    type: types.CHANGE_VERTICAL,
    vertical
  };
}

export function setMarket(market, baseUrl, origin) {
  return {
    type: types.SET_MARKET,
    market,
    baseUrl,
    origin,
    fullUrl: origin + baseUrl
  };
}

export function setQuery(query) {
  return {
    type: types.SET_QUERY,
    query: Object.assign({}, query)
  };
}

export function setEnvironment(isProduction) {
  return {
    type: types.SET_ENVIRONMENT,
    isProduction
  };
}
export function setLang(lang) {
  return {
    type: types.SET_LANG,
    lang
  };
}

export function errorPage(message = 'Error', status = 500) {
  return {
    type: types.ERROR_PAGE,
    message,
    status
  };
}



// WEBPACK FOOTER //
// ./actions/mode.js